import { BaseModel, supreme } from '@/supreme-core'
import util from '@/util/util'
import hybrid from '@/util/nativeHybrid'
import axios from 'axios'

const envInfo = util.getEnvInfo('monaConfig')
class MonaModel extends BaseModel {
	constructor(config) {
		config.timeout = 15000
		config.baseURL = config.baseURL || envInfo.baseUrl + envInfo.application + '/' + config.api
		super(config)
	}
	// 给接口传设备信息
	getMobileinfo() {
		let Info = hybrid.getOSInfo()
		if (Info) {
			return JSON.stringify(Info)
		} else {
			return JSON.stringify({ brand: 'web', model: 'web', os: 'web' })
		}
	}
	getToken() {
		return util.getToken()
	}
	post(param, config = {}) {
		if (!param) {
			param = {}
		}
		config.headers = {
			'Content-Type': 'application/json;charset=utf-8'
			// "mobileinfo": this.getMobileinfo()
			//   "mobileinfo":JSON.stringify({
			//   "version":"8.0.0",
			//   "channel":"dev",
			//   "device_type":"android",
			//   "device_model":"HWI-AL00",
			//   "device_id":"7529116c7bbde737",
			//   "device_brand":"HUAWEI",
			//   "network_type":"wifi",
			//   "is_iphonex_type":false,
			//   "is_full_screen":false,
			//   "ip_address":"unknown_ip",
			//   "os_lang":"zh",
			//   "os_timezone":"CN"
			// })
		}
		// 方便web本地测试使用
		// if (supreme.getQueryString("accessToken") || sessionStorage.getItem("accessToken")) {
		//   param['accessToken'] = supreme.getQueryString("accessToken") || sessionStorage.getItem("accessToken")
		// }
		if (this.getToken()) {
			// param["accessToken"] = this.getToken();
			config.params = {
				...config.params,
				accessToken: this.getToken()
			}
		}
		return super.post(param, config)
	}
	get(data, sub_path) {
		this.config.url = sub_path
		const config = {
			params: {
				accessToken: this.getToken(),
				...data
			}
		}
		if (this.config.needBrand) {
			config.headers = {
				'X-Request-Brand': data && data.brand ? data.brand : util.getBrand()
			}
		}
		return super.get(data, config)
	}
}
export default MonaModel
